module.exports = __webpack_public_path__ + "img/model_3.93fff86f.png";